import React from 'react';
import { Tooltip } from '@mui/material';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';

interface NoteIconProps {
  hasNotes: boolean;
}

/**
 * NoteIcon - Icon indicator for items that have notes
 * Shows a sticky note icon when hasNotes is true
 */
export const NoteIcon: React.FC<NoteIconProps> = ({ hasNotes }) => {
  if (!hasNotes) {
    return null;
  }

  return (
    <Tooltip title="Has notes">
      <StickyNote2Icon sx={{ fontSize: 18, color: 'text.secondary' }} />
    </Tooltip>
  );
};

export default NoteIcon;
